import { showFarmLocation } from '@app/api/farmLocations.api';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseSelect } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { Form } from 'antd';
import { useEffect, useState } from 'react';
import { FarmLocationDetails } from './FarmLocationDetails';
import React from 'react';

interface FarmLocationData {
  id: string;
  code: string;
  product_name: string;
  location_address: string;
  contact_no: string;
  fax_no: string;
  gps: string;
  status: string;
}

interface PRLocation {
  coordinates: any;
  label: string;
  value: number;
}

interface FarmLocationViewerProps {
  editable: boolean;
  title?: string;
  onFarmSelect?: (farm: FarmLocationData) => void;
  prLocations?: PRLocation[];
  prLocationData?: any;
  pr_type?: string;
}

const FarmLocationSelector = React.forwardRef<
  { getSelectedFarmId: () => string | null; getData: () => FarmLocationData | null },
  FarmLocationViewerProps
>(({ title = 'Farm Location Details', onFarmSelect, prLocations = [], prLocationData, editable, pr_type }, ref) => {
  const [selectedFarm, setSelectedFarm] = useState<FarmLocationData | null>(null);
  const [selectedFarmId, setSelectedFarmId] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  console.log('Passed PR Locations:', prLocations);
  console.log('Passed PR Location Data:', prLocationData);
  console.log('Form editable?:', editable);

  React.useImperativeHandle(ref, () => ({
    getSelectedFarmId: () => selectedFarmId || null,
    getData: () => selectedFarm,
  }));

  const farmOptions = prLocations.map((location) => ({
    label: location.label,
    value: location.value.toString(),
  }));

  // useEffect(() => {
  //   if (prLocationData && prLocationData.length > 0) {
  //     const farm = prLocationData[0];
  //     const transformed: FarmLocationData = {
  //       id: farm.id?.toString() || '',
  //       code: farm.code || '',
  //       product_name: farm.name || '',
  //       location_address: farm.address || '',
  //       contact_no: farm.contact_no || '',
  //       fax_no: farm.fax_no || '',
  //       gps: `${farm.latitude || ''}, ${farm.longitude || ''}`,
  //       status: farm.status || '',
  //     };
  //     setSelectedFarm(transformed);
  //     setSelectedFarmId(transformed.id);
  //   }
  // }, [prLocationData]);

  useEffect(() => {
    if (prLocationData) {
      // prLocationData is an object
      const farm = prLocationData;
      const transformed: FarmLocationData = {
        id: farm.id?.toString() || '',
        code: farm.code || '',
        product_name: farm.name || '',
        location_address: farm.address || '',
        contact_no: farm.contact_no || '',
        fax_no: farm.fax_no || '',
        gps: `${farm.latitude || ''}, ${farm.longitude || ''}`,
        status: farm.status || '',
      };
      setSelectedFarm(transformed);
      setSelectedFarmId(transformed.id);

      if (onFarmSelect) {
        onFarmSelect(transformed);
      }
    }
  }, [prLocationData, onFarmSelect]);

  const handleFarmSelection = async (value: unknown) => {
    const farmId = value as string;
    const numericId = parseInt(farmId, 10);

    setSelectedFarmId(farmId);
    setLoading(true);
    setError('');
    setSelectedFarm(null);

    try {
      const apiResponse = await showFarmLocation(numericId);
      const farmData = apiResponse.pr_location;

      const transformedData: FarmLocationData = {
        id: farmData.id?.toString() || farmId,
        code: farmData.code || '',
        product_name: farmData.name || '',
        location_address: farmData.address || '',
        contact_no: farmData.contact_no || '',
        fax_no: farmData.fax_no || '',
        gps: `${farmData.latitude || ''}, ${farmData.longitude || ''}`,
        status: farmData.status || '',
      };

      setSelectedFarm(transformedData);

      if (onFarmSelect) {
        onFarmSelect(transformedData);
      }
    } catch (err: any) {
      setError(err.message || 'Failed to fetch farm location data');
      console.error('Error fetching farm location:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '10px' }}>
      {editable === true && pr_type !== 'RENEW' && (
        <BaseRow gutter={[16, 16]}>
          <BaseCol xs={24} md={8}>
            <Form.Item name="farmSelection" required rules={[{ required: true, message: 'Please select a farm' }]}>
              <BaseSelect
                placeholder="Choose a farm to view details"
                options={farmOptions}
                value={selectedFarmId}
                onChange={handleFarmSelection}
                showSearch
                loading={loading}
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            </Form.Item>
          </BaseCol>
        </BaseRow>
      )}
      {error && (
        <div style={{ marginTop: '16px', color: 'red' }}>
          <p>Error: {error}</p>
        </div>
      )}

      {loading && (
        <div style={{ marginTop: '16px' }}>
          <p>Loading farm details...</p>
        </div>
      )}

      {selectedFarm && !loading ? (
        <div style={{ marginTop: '16px' }}>
          <FarmLocationDetails farmData={selectedFarm} title={title} loading={loading} />
        </div>
      ) : !loading && selectedFarmId && !error ? (
        <div style={{ marginTop: '16px' }}>
          <p>No data available for the selected farm.</p>
        </div>
      ) : !selectedFarmId && !loading ? (
        <>
          <br />
          <p>* Please select a farm from the dropdown above to view its details</p>
          <br />
        </>
      ) : null}
    </div>
  );
});

export default FarmLocationSelector;
